import { render, staticRenderFns } from "./LineItemEditor.vue?vue&type=template&id=3b590660&"
import script from "./LineItemEditor.vue?vue&type=script&lang=js&"
export * from "./LineItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b590660')) {
      api.createRecord('3b590660', component.options)
    } else {
      api.reload('3b590660', component.options)
    }
    module.hot.accept("./LineItemEditor.vue?vue&type=template&id=3b590660&", function () {
      api.rerender('3b590660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/templates/invoices/schema/LineItemEditor.vue"
export default component.exports